import VueSocketIO from 'vue-socket.io'
import { websocketUrl } from '../../config/env'
export default new VueSocketIO({
  debug: false,
  connection: websocketUrl,
  vuex: {}
})
